import React from 'react';
import { EditFormTemplatePage } from '../EditFormTemplatePage/EditFormTemplatePage';
import { GenerateFormTemplatePage } from '../GenerateFormTemplatePage/GenerateFormTemplatePage';

type EditFormTemplateFieldsPageProps = {
  formWizardBasePath: string;
  isEditMode: boolean;
};

export function EditFormTemplateFieldsPage({
  formWizardBasePath,
  isEditMode,
}: EditFormTemplateFieldsPageProps) {
  return isEditMode ? (
    <EditFormTemplatePage formWizardBasePath={formWizardBasePath} />
  ) : (
    <GenerateFormTemplatePage formWizardBasePath={formWizardBasePath} />
  );
}
